// 화상 중계(TURN·SFU) 사용량: 서버 /usage가 돌려준 값 그대로 (창이 열려 있는가 포함)
export const USE: { open: boolean; u: any } = { open: false, u: null };
